import { LoginFormPage, ProConfigProvider, ProFormText } from '@ant-design/pro-components';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import loginBg from '../assets/login-bg.svg';
import logoPet from '../assets/logo-pet.svg';

export default function Login() {
  const navigate = useNavigate();
  type LoginValues = { username: string; password: string };
  type ApiError = { response?: { data?: { message?: string } } };

  const handleFinish = async (values: LoginValues) => {
    try {
      const res = await api.post('/admin/login', values);
      localStorage.setItem('admin_token', res.data.access_token);
      message.success('登录成功');
      navigate('/');
    } catch (error: unknown) {
       const apiMessage = (error as ApiError).response?.data?.message;
       message.error(apiMessage || '登录失败');
    }
  };

  return (
    <ProConfigProvider>
      <div style={{ backgroundColor: 'white', height: '100vh' }}>
        <LoginFormPage
          backgroundImageUrl={loginBg}
          logo={logoPet}
          title="班级宠物系统"
          subTitle="后台管理"
          onFinish={handleFinish}
        >
          <ProFormText
            name="username"
            fieldProps={{
              size: 'large',
              prefix: <UserOutlined />,
            }}
            placeholder={'用户名'}
            rules={[{ required: true, message: '请输入用户名!' }]}
          />
          <ProFormText.Password
            name="password"
            fieldProps={{
              size: 'large',
              prefix: <LockOutlined />,
            }}
            placeholder={'密码'}
            rules={[{ required: true, message: '请输入密码!' }]}
          />
        </LoginFormPage>
      </div>
    </ProConfigProvider>
  );
}
